import React from 'react'
import PropTypes from 'prop-types'
import Firebase from '../services/firebase'
import {loadStripe} from '@stripe/stripe-js';
import { 
  Form,
  Grid,
  Header,
  Message,
  Button,
  Segment,
} from "semantic-ui-react";

export class  SettingPageTemplate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: "",
      location: "",
      lastName: "",
      isLoading:false,
      darkMode: false,
      emailButtonText:"Submit",
      emailButtonTextAnimation:"Thanks, We'll keep you in the loop",
      validSubmit: false,
      user: null,
      loading: true

    };

    Firebase.auth().onAuthStateChanged(function (user) {

      if (user) {
        // User is signed in.
        this.setState({ 'user':  Firebase.auth().currentUser });
        this.setState({ 'loading': false });
      } else {
        // No user is signed in.
        this.setState({ 'user': null });
        this.setState({ 'loading': false });
      }
    }.bind(this)).bind(this);

    this.handleChangeFirstName = this.handleChangeFirstName.bind(this);
    this.handleChangeLastName = this.handleChangeLastName.bind(this);
    this.handleChangeLocation = this.handleChangeLocation.bind(this);
    this.handleChangeDarkMode = this.handleChangeDarkMode.bind(this);
    this.toggle = this.toggle.bind(this);
    this.submitInfo = this.submitInfo.bind(this);
    this.subscribeToPlan = this.subscribeToPlan.bind(this);

    this.updateValidButtonSubmit = this.updateValidButtonSubmit.bind(this);

  }

  toggle = () => {
    this.setState(({ darkMode }) => ({ darkMode: !darkMode }));
    window.sessionStorage.setItem("darkMode", !this.state.darkMode? "on":"off");
  };

  componentWillMount() {
    if(typeof window !== 'undefined'){
      this.setState(({ darkMode }) => ({ darkMode:  window.sessionStorage.getItem("darkMode") === "on"}));
    }
  }

  handleChangeFirstName = event => {
    let text = event.target.value;
    this.setState({
      "firstName": text
    });
  };

  handleChangeLastName = event => {
    let text = event.target.value;
    this.setState({
      "lastName": text
    });
  };

  handleChangeDarkMode = (e, { checked }) => {
    this.toggle()
  };

  handleChangeLocation = event  => {
    let text = event.target.value;
    this.setState({
      "location": text
    });
  };



  updateValidButtonSubmit = () => {
    let isValid = ((this.state.password === this.state.confirmedPassword) && (this.state.password !== "")  );
    this.setState({ 'validSubmit': isValid });
  };

  validateEmail= email =>{
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
    return re.test(String(email).toLowerCase());
  };


  //price_1GvCEVEeNhsmrZyAuipadnKZ
  submitInfo =  () => {

    var callUserProfile = Firebase.functions().httpsCallable('createUserProfile');
    const profileUpdate = {
      "email": Firebase.auth().currentUser.email,
      "subscribed":false,
      "name":this.state.firstName + " "+ this.state.lastName,
      "location":this.state.location
    };
    callUserProfile(profileUpdate).then(function(result) {
      // Read result of the Cloud Function.
      console.log(result.data);
      console.log(result);
      console.log(result.toString());
      // ...
    });

  };

  subscribeToPlan =  async () => {
    this.setState(({ isLoading }) => ({ isLoading: true }));
    const stripe = await loadStripe('pk_test_a5EVbwuFXfYZf7vfxX6a9sHI00aMrDjDlB');

    var callUserProfile = Firebase.functions().httpsCallable('stripeCheckout');
    const profileUpdate = {
      "price": "price_1GvCEVEeNhsmrZyAuipadnKZ",
      "quantity": 1,
      "mode": "subscription"
    };
    callUserProfile(profileUpdate).then(function(result) {
      // Read result of the Cloud Function.
      stripe.redirectToCheckout({
        // Make the id field from the Checkout Session creation API response
        // available to this file, so you can provide it as parameter here
        // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
        sessionId: result.data.checkoutSessionId
      }).catch((err) => {
        console.error(err);
      });
    });
  };

  render() {
    return (
      <div>
        <div
          style={{
            display: 'flex',
            height: '100%',
            lineHeight: '1',
            justifyContent: 'space-around',
            alignItems: 'left',
            flexDirection: 'column',
          }}
        >
        </div>
        <div className="content has-text-centered">
          <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
            <Grid.Column style={{ maxWidth: 450 }}>
              <Header as='h2' color='blue' textAlign='center'>
                Account Settings
              </Header>
              <Form className='large' >
                <Segment stacked>
                  <Message
                    attached
                    header='Lets Get To Know Each Other!'
                  />
                  <Form.Group widths='equal'>
                  </Form.Group>
                  <Form.Field>
                    <input placeholder='First Name' type='text' name='firstName' onInput={this.handleChangeFirstName}/>
                  </Form.Field>
                  <Form.Field>
                    <input placeholder='Last Name' type='text' name='lastName'  onInput={this.handleChangeLastName}/>
                  </Form.Field>
                  <Form.Field>
                    <input placeholder='Location' type='text' name='location' onInput={this.handleChangeLocation} />
                  </Form.Field>
                  {/* <Form.Field>
                    <Checkbox label="Dark Mode"
                              checked={this.state.darkMode}
                              onChange={this.handleChangeDarkMode}
                              toggle />
                  </Form.Field> */}
                  <Button   fluid={true} size={'large'} color={'blue'} animated={"vertical"}   onClick={this.submitInfo}>
                    <Button.Content visible>{this.state.emailButtonText}</Button.Content>
                    <Button.Content hidden>
                      {this.state.emailButtonTextAnimation}
                    </Button.Content>
                  </Button>
                  {/*<Divider horizontal>Also, Why Not Subscribe?</Divider>*/}
                  {/*<Modal trigger={ <Button  animated='fade'  fluid size='large'  color='orange'>*/}
                    {/*<Button.Content visible> Subscribe*/}
                    {/*</Button.Content>*/}
                    {/*<Button.Content hidden>*/}
                      {/*That's a GOOD choice*/}
                    {/*</Button.Content>*/}
                  {/*</Button>*/}
                  {/*} basic size='small'>*/}
                    {/*<Header icon='music' content='Subscribe To The GMGT Plan' />*/}
                    {/*<Modal.Content>*/}
                      {/*<p>*/}
                        {/*Subscribe to GMGT, and receive the following benefits. <br/>*/}
                        {/*1. Access to Exclusive in Studio Events <br/>*/}
                        {/*2. Free shipping on all orders<br/>*/}
                        {/*3. Early bird access & pricing to tickets & merchandise<br/>*/}
                      {/*</p>*/}
                    {/*</Modal.Content>*/}
                    {/*<Modal.Actions>*/}
                      {/*<Button color='green'  loading={this.state.isLoading} onClick={this.subscribeToPlan}>*/}
                        {/*<Icon name='checkmark' /> Yes*/}
                      {/*</Button>*/}
                    {/*</Modal.Actions>*/}
                  {/*</Modal>*/}


                </Segment>
              </Form>
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  }
}

SettingPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  mainpitch: PropTypes.object,
  description: PropTypes.string,
  intro: PropTypes.shape({
    blurbs: PropTypes.array,
  }),
}

const SettingnPage = ({ data }) => {
  return (
    <div>
      <SettingPageTemplate />
    </div>

  )
}

SettingnPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default SettingnPage;
